import { Component } from "@mna/react";
import { classnames as cx } from "@mna/react";
import { Trans } from "react-i18next";
import i18next from "i18next";

function rightSideMenuClick(e, item, state, history, actions, setState){
  e.preventDefault();
  if (state.isMenuClick) {
    if (
      i18next.t(item.name.props.i18nKey) ==
      i18next.t("Menulist.Aboutme") &&
      state.isTravelAid2 && state.LocationScreen
    ) {
      actions.resetQTState(state, setState);
      state.triageRequest.activeMenu = item.link;
      history.push(`/find-care-options/send-information`);
    }
    else if (
      i18next.t(item.name.props.i18nKey) ==
      i18next.t("Menulist.Aboutme") &&
      state.triageRequest.birthdateSelected
    ) {
      actions.resetQTState(state, setState);
      state.triageRequest.activeMenu = item.link;
      history.push(`/find-care-options/${item.link}`);
    } else if (
      i18next.t(item.name.props.i18nKey) ==
      i18next.t("Menulist.Location") &&
      state.triageRequest.location.hasOwnProperty("name")
    ) {
      if(!state.quickTelemedicine){
        actions.resetQTState(state, setState);
      }
      state.triageRequest.activeMenu = item.link;
      history.push(`/find-care-options/${item.link}`);
    } else if (
      i18next.t(item.name.props.i18nKey) ==
      i18next.t("Menulist.Symptoms") &&
      state.triageRequest.Symptoms.length > 0
    ) {
      state.triageRequest.activeMenu = item.link;
      history.push(`/find-care-options/${"symptoms"}`)

    }
    else if (
      i18next.t(item.name.props.i18nKey) ==
      i18next.t("Menulist.interview") &&
      state.triageRequest.questions.hasOwnProperty("question") && state.triageRequest.questions.question != null
    ) {
      state.triageRequest.activeMenu = item.link;
      history.push(`/find-care-options/${item.link}`);
    } else if (
      i18next.t(item.name.props.i18nKey) ==
      i18next.t("Menulist.related") &&
      state.triageRequest.RelatedSymptoms.length > 0
    ) {
      state.triageRequest.activeMenu = item.link;
      history.push(`/find-care-options/${item.link}`);
    }
    else if (
      i18next.t(item.name.props.i18nKey) ==
      i18next.t("Menulist.selectcare") && state.isTravelAid2 &&
      state.isEmrgencyAnswerAdded
    ) {
      var redirectPage = item.link;
      if(state.triageRequest.selectedCareOptionName == "Medical Facility" || state.triageRequest.selectedCareOptionName == "Clinic"){
      actions.generateRecommendedCareOptions();
      state.triageRequest.activeMenu = redirectPage;
      history.push(`/find-care-options/${redirectPage}`);
      return state.triageResponse.recommendedCareOptions;
      }
      else{
        var vendorArrayList = state.triageResponse.vendorsList;
          var vendorsLength = 0;
          if(vendorArrayList){
            vendorsLength = vendorArrayList.length;
          }
          
          if (vendorsLength === 0) {
            history.push(`/find-care-options/telemedicine-info`);
          } else if (vendorsLength >= 1) {
            var vendorSupportedModal =
              vendorArrayList[0].accessInformation.virtualAccessInformation
                .webAccessReferences[0].supportedModalities;
                state.triageRequest.supportedModalities = vendorSupportedModal.length
            if (vendorSupportedModal.length >= 2) {
              //both option
              history.push(`/find-care-options/telemed-connectiontype`);
            } else {
              if (vendorSupportedModal[0] === "Video") {
                //redirect to video prompt
                state.triageResponse.selectedConnectionType="2"
                history.push(`/find-care-options/telemed-videoprompt`);
              } else {
                //redirect to connection page
                state.triageResponse.selectedConnectionType="1"
                history.push(`/find-care-options/telemedicine-info`);
              }
            }
          } else if (vendorsLength > 1) {
            var allVendorsArray = [];
            state.triageResponse.vendorsList.map((item) => {
              var vendors = item.nameLocalization.localizations[0].value;
              if (allVendorsArray.indexOf(vendors) === -1) {
                allVendorsArray.push(vendors);
              }
            });
            if (allVendorsArray.length >= 1) {
              var vendorSupportedModalities =
                vendorArrayList[0].accessInformation.virtualAccessInformation
                  .webAccessReferences[0].supportedModalities;
             
              if (vendorSupportedModalities.length >= 2) {
                //both option
                history.push(`/find-care-options/telemed-connectiontype`);
              } else {
                if (vendorSupportedModalities[0] === "Video") {
                  state.triageResponse.selectedConnectionType="2"
                  //redirect to video prompt
                  history.push(`/find-care-options/telemed-videoprompt`);
                } else {
                  state.triageResponse.selectedConnectionType="1"
                  //redirect to connection page
                  history.push(`/find-care-options/telemedicine-info`);
                }
              }
            } else {
              history.push(`/find-care-options/telemedicine-info`);
            }
          }
  
      }

    }
    else if (
      i18next.t(item.name.props.i18nKey) ==
      i18next.t("Menulist.selectcare") &&
      state.triageResponse.recommendedCareOptions.length > 0 &&
      !state.isTravelAid2
    ) {
      var redirectPage = item.link;
      if (state.UserNavigatedToQT) {
        redirectPage = "quick-telemedicine-screen"
      }
      state.triageRequest.activeMenu = "care-options";
      history.push(`/find-care-options/${redirectPage}`);
    } else if (
      i18next.t(item.name.props.i18nKey) ==
      i18next.t("Menulist.selectcare") &&
      (state.triageRequest.emergency || state.isFacility) &&
      state.triageRequest.location.hasOwnProperty("name")
    ) {
      state.triageRequest.activeMenu = item.link;
      history.push(`/find-care-options/${item.link}`);
    } else if (
      state.isTravelAid2 && i18next.t(item.name.props.i18nKey) ==
      i18next.t("Menulist.related") &&
      state.RelatedSymptomInfo.length > 0
    ) {
      state.triageRequest.activeMenu = item.link;
      history.push(`/find-care-options/${"symptoms"}`)

    }

  }

}
const MenuItems = ({
  items,
  history,
  state,
  setState,
  actions
}) => {
  function arrayRemove(arr, value) {
    return arr.filter(function (ele) {
      return ele.name != value;
    });
  }
  if (!state.triageRequest.emergency && !state.isFacility && !state.isTravelAid2) {

    items = arrayRemove(items, "Symptoms ");
    items.splice(2, 0, {
      name: <Trans i18nKey="Menulist.Symptoms">Symptoms</Trans>,
      link: "symptoms",
    });
  }
  if (state.UserNavigatedToQT || state.quickTelemedicine) {
    const excludeMenuItemsList = ["symptoms", "related-symptoms", "questions"]; // menu's that we want to remove

    var filteredItem = items.filter(function (element) {
      return !excludeMenuItemsList.includes(element.link);
    });

    //clear
    items.splice(0, items.length);

    //new menu list
    items.push(...filteredItem);
  }
  return (
    <div role="navigation" className="standymd-sidemenu">
      {items.map((item, index) => (
        <ul key={index} className={cx(
          state.isFacility == false
            ? (state.defaultLanguageCode === "de" ? "standymd-sidemenu-font-german" : state.defaultLanguageCode === "es" ? "standymd-sidemenu-font-spanish" : "standymd-sidemenu-font") : "standymd-sidemenu-font",
          state.triageRequest.activeMenu == item.link ? (state.defaultLanguageCode === "de"
            ? "activeForGer"
              : "active")
            : ""
        )}>
          <li>
            <a
              key={item.name}
              href="#"
              onClick={(e) => {
                rightSideMenuClick(e, item, state, history, actions, setState)
              }}
              onKeyDown={(e)=>{
                if(e.key === " " || e.key ==="Spacebar"){
                  rightSideMenuClick(e, item, state, history, actions, setState)
                }
              }}
            >
              {" "}
              {item.name}
            </a>
          </li>
        </ul>
      ))}
    </div>
  );
};

class Menu extends Component {
  render() {
    const {
      items,
      history,
      state,
      actions,
      setState,
      nextStepName,
    } = this.props;
    return (
      <MenuItems
        {...{ items, history, state, actions, setState, nextStepName }}
      />
    );
  }
}

export default Menu;
